import axios from '../utils/axios';

const apiPrefix = '/api/profile';

const update = (params) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/profile/update', params)
			.then((res) => {
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
	});
};

const completeOnboarding = (onboardingData) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/profile/onboarding/complete', { options: onboardingData })
			.then((res) => {
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
	});
};

const changeEmail = (email) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/profile/change-email', { email })
			.then((res) => {
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
	});
};

const changePassword = ({ current_password, new_password, new_password_confirmation }) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/profile/change-password', { current_password, new_password, new_password_confirmation })
			.then((res) => {
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
	});
};

const sendResetPasswordLink = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/reset-password')
			.then((res) => {
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
	});
};

const markHomePassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-home-passed')
			.then(resolve).catch(reject);
	});
};

const deleteAccount = (params) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/profile/delete', params)
			.then(resolve).catch(reject);
	});
};

const markNetworkingPassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-networking-passed')
			.then(resolve).catch(reject);
	});
};

const markColdEmailingPassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-cold-emailing-passed')
			.then(resolve).catch(reject);
	});
};

const markResumePassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-resume-passed')
			.then(resolve).catch(reject);
	});
};

const markBuilderPassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-builder-passed')
			.then(resolve).catch(reject);
	});
};

// EN-806: marks the shorter "what's new" ResumAI scoring tour (for existing users) as seen.
const markResumeScoreWhatsNewPassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-resume-score-whats-new-passed')
			.then(resolve).catch(reject);
	});
};


const markCoverLetterPassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-cover-letter-passed')
			.then(resolve).catch(reject);
	});
};

const markJobSearchPlanTutorialPassed = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/profile/mark-job-search-plan-passed')
			.then(resolve).catch(reject);
	});
};

const applyFreeFeatures = () => {
	return new Promise((resolve, reject) => {
		axios.post('/api/apply-free-features')
			.then(({ data }) => resolve(data)).catch(reject);
	});
};

const getJobTitleRecommendations = async () => {
	const response = await axios.get('/api/profile/get-recommended-job-titles');
	return response.data;
};

const saveJobTitle = async (title) => {
	const response = await axios.post('/api/profile/job-title', {
		job_title: title
	});

	return response.data;
};

const submitJobSearchProfile = async (payload) => {
	const response = await axios.post(`${apiPrefix}/job-search-profile`, payload);
	return response.data;
};

export {
	sendResetPasswordLink,
	deleteAccount,
	update,
	changeEmail,
	changePassword,
	markHomePassed,
	markNetworkingPassed,
	markResumePassed,
	markBuilderPassed,
	markResumeScoreWhatsNewPassed,
	markCoverLetterPassed,
	markJobSearchPlanTutorialPassed,
	applyFreeFeatures,
	markColdEmailingPassed,
	completeOnboarding,
	getJobTitleRecommendations,
	saveJobTitle,
	submitJobSearchProfile
};
